import { Llamado, LlamadoListado } from '../../models/Entities/Turnero';
import { CommonState } from '../common/state/commonState';

export interface TurneroLlamadosState extends CommonState<Llamado> {
    ultimos: LlamadoListado[];
    purgedCount: number | undefined;

    isLoadingUltimos: boolean;
    successLoadingUltimos: boolean | undefined;
    failOnLoadingUltimos: boolean;

    isCreating: boolean;
    successCreating: boolean | undefined;
    failOnCreating: boolean;

    isPurgingOld: boolean;
    successPurgingOld: boolean | undefined;
    failOnPurgingOld: boolean;
}

export const TurneroLlamadosUnloadState: any = {
    // loading all
    isLoadingAll: false,
    isLoadingAllSuccess: undefined,
    FailGettingAll: false,

    // updating all
    isUpdatingAll: false,
    isUpdatingAllSuccess: undefined,
    FailUpdatingAll: false,

    // loading one
    isLoadingOne: false,
    isLoadingOneSuccess: undefined,
    FailGettingOne: false,

    // updating
    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,
    
    // adding
    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    // deleting
    isDeletingOne: false,
    isDeletingOneSuccess: undefined,
    FailDeletingOne: false,

    // list and error
    list: [],
    error: undefined,

    // custom
    ultimos: [],
    purgedCount: undefined,

    isLoadingUltimos: false,
    successLoadingUltimos: undefined,
    failOnLoadingUltimos: false,

    isCreating: false,
    successCreating: undefined,
    failOnCreating: false,

    isPurgingOld: false,
    successPurgingOld: undefined,
    failOnPurgingOld: false
};
